// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"VideoPlayer_videoContainer__oMc7T"};